import FeatureFlag from 'App/components/FeatureFlag';
import { NEW_ADMIN_WHATSAPP_NOTIFICATIONS } from 'App/featuresFlags';
import HelpLink from 'App/HelpLink';
import { useHasTags } from 'App/hooks';
import {
  ErrorScreen,
  HeaderContent,
  IonPageStratus,
  Stack,
} from 'commons/components';
import { HELP_LINKS_NOTIFICATIONS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import {
  EmailOriginInfo,
  EmailsSection,
  NotificationsListPageSkeleton,
} from './components';
import {
  useGetEmailsListQuery,
  useGetWhatsappNotificationListQuery,
} from '../../notificationsApi';
import { WhatsAppBanner } from '../EditNotificationPage/components';
import './NotificationsListPage.scss';

function NotificationsListPage() {
  const language = useTranslationLanguage();
  const t = useTranslationConfigurations('notifications.notificationsListPage');
  const [hasWhatsappNotificationsTag] = useHasTags(
    NEW_ADMIN_WHATSAPP_NOTIFICATIONS,
  );

  const { data: emails, isLoading, isError, refetch } = useGetEmailsListQuery();

  const { data: whatsappNotifications } = useGetWhatsappNotificationListQuery(
    undefined,
    {
      skip: !hasWhatsappNotificationsTag,
    },
  );

  const showSkeleton = isLoading;
  const showError = isError;
  const showList = !showSkeleton && !showError && !!emails;

  return (
    <IonPageStratus
      width="medium"
      headerContent={
        <HeaderContent
          title={t(hasWhatsappNotificationsTag ? 'alternativeTitle' : 'title')}
          subtitle={t('subtitle')}
        />
      }
    >
      <Stack column align="flex-start" spacing="base">
        <EmailOriginInfo />
        <FeatureFlag flag={NEW_ADMIN_WHATSAPP_NOTIFICATIONS}>
          {showList && <WhatsAppBanner />}
        </FeatureFlag>
        {showSkeleton && <NotificationsListPageSkeleton />}
        {showError && <ErrorScreen onRetry={refetch} />}
        {showList && (
          <Stack column align="stretch" spacing="loose">
            <EmailsSection
              title={t('emailTypes.promotions')}
              emails={emails.promotions}
              whatsappNotifications={whatsappNotifications?.items}
              showApp
            />
            <EmailsSection
              title={t('emailTypes.accounts')}
              emails={emails.accounts}
              whatsappNotifications={whatsappNotifications?.items}
            />
            <EmailsSection
              title={t('emailTypes.orders')}
              emails={emails.orders}
              whatsappNotifications={whatsappNotifications?.items}
            />
          </Stack>
        )}
      </Stack>
      <HelpLink
        title={t('helpLink.title')}
        previousValue=""
        currentViewTracking={t('helpLink.amplitudeName')}
        linkURL={HELP_LINKS_NOTIFICATIONS[language]}
        hasDisclaimer={false}
        icon="both"
      />
    </IonPageStratus>
  );
}

export default NotificationsListPage;
